import fetchClient from '../utils/fetchClient';

// Получить основные игровые данные для верхней панели
export const getUserGameDataSummary = async () => {
    return fetchClient.get('/user-game-data/summary');
};

// Получить полные игровые данные пользователя
export const getUserGameData = async () => {
    return fetchClient.get('/user-game-data/');
};

// Обновить игровые данные
export const updateUserGameData = async (data) => {
    return fetchClient.put('/user-game-data/', data);
};

// Добавить опыт пользователю
export const addExperience = async (experiencePoints) => {
    return fetchClient.post('/user-game-data/add-experience', { experience_points: experiencePoints });
};

// Добавить энергию пользователю
export const addEnergy = async (energyPoints) => {
    return fetchClient.post('/user-game-data/add-energy', { energy_points: energyPoints });
};

// Потратить энергию пользователя
export const spendEnergy = async (energyPoints) => {
    return fetchClient.post('/user-game-data/spend-energy', { energy_points: energyPoints });
};

// Обновить количество заданий
export const updateQuestsCount = async (questsCount) => {
    return fetchClient.post('/user-game-data/update-quests-count', { quests_count: questsCount });
};

// Получить топ игроков
export const getTopPlayers = async (limit = 20, offset = 0) => {
    return fetchClient.get(`/user-game-data/top-players?limit=${limit}&offset=${offset}`);
};

// Обновить позиции в топе (для администратора)
export const updateRankPositions = async () => {
    return fetchClient.post('/user-game-data/update-rank-positions');
};

// Получить информацию об уровне пользователя
export const getLevelInfo = async () => {
    return fetchClient.get('/user-game-data/level-info');
};

// Получить прогрессию уровней
export const getLevelProgression = async (startLevel = 1, endLevel = 20) => {
    return fetchClient.get(`/user-game-data/level-progression?start_level=${startLevel}&end_level=${endLevel}`);
};

// Получить награды за уровень
export const getLevelRewards = async (level) => {
    return fetchClient.get(`/user-game-data/level-rewards/${level}`);
};

// Добавить опыт (новая версия)
export const addExperienceV2 = async (experiencePoints) => {
    return fetchClient.post('/user-game-data/add-experience-v2', { experience_points: experiencePoints });
}; 